import { actionTypes } from '../actions/types';
import ApplicationStatus from '../util/mappings/applicationStatus';
import SigningStatus from '../util/mappings/signingStatus';

type AppActions = import('../actions/types').AppActions;

export interface StepsReducer {
    currentStep: number;
}

export const initialState: StepsReducer = {
    currentStep: 1,
};

export const stepsReducer = (state = initialState, action: AppActions = {} as AppActions): StepsReducer => {
    switch (action.type) {
        case actionTypes.OPEN_STEP: {
            const destinationStep = action.payload as number;
            return { ...state, currentStep: destinationStep };
        }
        case actionTypes.SEND_APPLICATION_FULFILLED:
        case actionTypes.FETCH_APPLICATION_FULFILLED:
        case actionTypes.UPDATE_APPLICATION_FULFILLED: {
            const applicationStatus = action.payload?.applicationStatus;
            const esigningStatus = action.payload?.esigningStatus || '';
            const signedByCurrentUser = action.payload?.signedByCurrentUser || false;
            const missingVariables = action.payload?.missingVariables || [];

            if (esigningStatus === SigningStatus.ongoingSigning) {
                return { ...state, currentStep: 6 };
            }

            if (
                applicationStatus === ApplicationStatus.documentsSent &&
                [SigningStatus.notFound, SigningStatus.notSigned].includes(esigningStatus) &&
                missingVariables.length === 0
            ) {
                return { ...state, currentStep: 6 };
            }

            if (
                applicationStatus === ApplicationStatus.documentsSent &&
                esigningStatus === SigningStatus.partiallySigned &&
                missingVariables.length === 0
            ) {
                return { ...state, currentStep: signedByCurrentUser ? 7 : 6 };
            }

            if (
                applicationStatus === ApplicationStatus.documentsComplete ||
                (applicationStatus === ApplicationStatus.documentsSent && esigningStatus === SigningStatus.signed)
            ) {
                return { ...state, currentStep: 7 };
            }
            return state;
        }
        case actionTypes.UPDATE_STEPS_COMPLETION: {
            return state;
        }
        default:
            return state;
    }
};
